import type { Appearance } from "@stripe/stripe-js"
import { useColors } from "@mallardbay/lib-react-components"

import type { StripeSetupIntentFieldsFragment } from "~graphql/generated/graphql"

const FONT_URL =
    "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700&display=swap"

export function useStripeOptions(
    setupIntent: StripeSetupIntentFieldsFragment | null | undefined
) {
    const appearance = useStripeElementsAppearance()

    const stripeElementsOptions = { fonts: [{ cssSrc: FONT_URL }] }
    const clientSecret = setupIntent?.client_secret ?? ""

    return { clientSecret, appearance, ...stripeElementsOptions }
}

function useStripeElementsAppearance(): Appearance {
    const { text, dangerColor, backgroundSecondary } = useColors()

    return {
        theme: "flat",
        variables: {
            fontFamily: `"Nunito Sans", sans-serif`,
            borderRadius: "8px",
            colorText: text,
            colorDanger: dangerColor,
            colorBackground: backgroundSecondary,
            colorPrimary: "#f65e38",
        },
    }
}
